import { Link, Navigate } from 'react-router-dom';
import { PageHeader } from '@/shared/ui';
import { TextingSettingsPage } from '@/modules/texting/pages/TextingSettingsPage';
import { SettingsFrame, SettingsNote } from '../components/SettingsFrame';
import { useSettingsSections } from '../hooks';
import styles from './SettingsPage.module.css';

/**
 * Settings > Communication: how PracticeNova texts and calls for the practice, for every section that uses them.
 * Texting shows when a module that texts is on (text review requests, patient referrals); Call Settings when Calls
 * is on. With neither, the page is not offered.
 */
export function CommunicationSettingsPage() {
  const sections = useSettingsSections();
  if (sections.loading) return null;
  if (!sections.communication) return <Navigate to="/settings/practice" replace />;
  return (
    <div className={styles.page}>
      <PageHeader
        title="Communication Settings"
        subtitle="How PracticeNova texts and calls on the practice's behalf, for every section that uses them."
      />
      {sections.texting && <TextingSettingsPage embedded />}
      {sections.callSettings && (
        <SettingsFrame embedded id="settings-call-settings" title="Call Settings">
          {/* Each number the practice uses, linked to where it is managed. More kinds come here later. */}
          <SettingsNote>
            Tracking numbers (ads, landing pages and mailers, answered by the AI agent) are managed
            in{' '}
            <Link to="/settings/operations#settings-call-numbers-section">
              Operations Settings › Calls › Tracking Numbers
            </Link>
            .
          </SettingsNote>
        </SettingsFrame>
      )}
    </div>
  );
}
